<template>
    <div class="userInfo-wrapper"
         v-if="order_data.finance.express ">
        <div class="userInfo-border">
            <h5>
                地址信息
                <el-button size="mini" type="primary" @click="dialogExpressTable">添加地址信息</el-button>
            </h5>
            <div class="userInfo-group" v-if="order_data.finance.express.length == 0"
                 style="text-align:center; font-size:14px; color:#909399;">暂无数据
            </div>
            <el-row class="userInfo-group" v-for="item in order_data.finance.express" :key="item.id"
                    v-else>
                <el-row>
                    <el-col :span="12" class="order-item">收件人姓名：<span>{{item.name}}</span></el-col>
                    <el-col :span="12" class="order-item">联系方式：<span>{{item.mobile}}</span></el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" class="order-item">寄件地址：
                        <span>
                            {{item.label_name + item.address}}
                        </span>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12" class="order-item">
                        邮寄方式：<span>{{ expressOptions.find(res=>{
                                return res.value == item.express_company;
                        })['label']  }}</span>
                    </el-col>
                    <el-col :span="4" :offset="8">
                        <!-- 添加表单 -->
                        <ExpressForm v-if="Acs('/order-express/update')" buttonName="编辑" :expressForm='item' @change='updateExpress'></ExpressForm>
                        <el-button size="small" type="primary" @click="deleteExpressTable(item)" :loading="delete_loading">删除</el-button>
                    </el-col>
                </el-row>
                <!-- <el-row v-if="item.fee">
                    <el-col :span="12" class="order-item">邮费：<span>{{item.fee}}元</span>
                    </el-col>
                </el-row> -->
                <el-row>
                    <el-col :span="12" class="order-item">备注信息：<span>{{item.memo != "" ? item.memo : "暂无"}}</span>
                    </el-col>
                </el-row>
            </el-row>
        </div>
        <!-- 添加表单 -->
        <express-table :expressForm='expressForm' v-if="dialogExpressVisible" @handleAddExpress='addExpress'></express-table>
    </div>
</template>
<script>
    import {OrderMixin} from "~/services/OrderMixin";
    import DistrictLinkage from "~/widgets/DistrictLinkage.vue";
    import ExpressForm from "~/views/order/dialog/expressForm.vue";
    import ExpressTable from "~/views/order/expressTable.vue";
    import OrderExpressService from '~/services/OrderExpress';
    import OrderService from '~/services/order';

    export default {
        mixins: [OrderMixin],
        components: {
            DistrictLinkage,
            ExpressForm,
            ExpressTable
        },

        data() {
            return {
                province: [],
                expressForm: {},
                order_data: {},
                dialogExpressVisible: false,
                expressForm: null, // 快递表单
                delete_loading: false,
            }
        },

        props: {
            order: {
                required: true
            },
        },

        created() {
            this.order_data =  _.clone(this.order);
        },

        watch: {
            order: {
                handler(newVal) {
                    this.order_data = _.clone(newVal);
                },
                deep: true
            }
        },

        methods: {
            updateExpress(val){
                let index = this.order_data.finance.express.findIndex(function(item) {
                    return item.id == val.id;
                });

                if (index != -1) {
                    this.$set(this.order_data.finance.express, index, Object.assign({}, val));
                }
            },

            dialogExpressTable() {
                this.expressForm = null;
                // if (this.order_data.finance.express.length > 0) {
                //     this.$message({
                //         message: "已存在地址信息，请勿重复添加",
                //         type: "error"
                //     });
                //     return false;
                // }
                this.dialogExpressVisible = true;
                return true;
            },

            deleteExpressTable(row){
                this.$confirm("你确定要删除该地址信息吗？", "温馨提示", {type: "warning"}).then(ok => {
                    this.delete_loading = true;
                    OrderExpressService.delete(row.id).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                message:'删除成功',
                                type:'success'
                            });
                            this.order_data.finance.express = this.order_data.finance.express.filter(item => item.id != row.id);
                        }
                        this.delete_loading = false;
                    }).catch(err => {
                        console.error(err)
                        this.delete_loading = false;
                    });
                    return true;
                }).catch(cancel => {
                    return false;
                });
            },

            addExpress(form) {
                if (form) {
                    delete form.id;
                    form.order_id = this.order_data.id;
                    OrderExpressService.create(form).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                message:'添加成功',
                                type:'success'
                            });
                            // 重新拉取订单详情以获取完整的地址信息（包含label_name等）
                            OrderService.getDetail(this.order_data.id).then(detailRes => {
                                if (detailRes && detailRes.data && detailRes.data.finance && detailRes.data.finance.express) {
                                    this.order_data.finance.express = detailRes.data.finance.express;
                                } else {
                                    // 降级处理：如果拉取失败，尝试使用返回的数据
                                    this.order_data.finance.express.push(res.data);
                                }
                            });
                        }
                    }).catch(err => {
                        console.error(err)
                    });
                }
                this.dialogExpressVisible = false;
            },
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/partial/order_address.vue